import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { Col, Row } from "@/utils/bootstrap";
import { getOptionAvailability } from "../../common-filters-components/option-availability";
import {
  isSelected,
  toggleOption,
} from "../../common-filters-components/toggleOption";
import ButtonOption from "../../common-filters-components/ButtonOption";
import SvgColorOption from "../../common-filters-components/SvgColorOption";
import { useState } from "react";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  filter: IFilter;
  state: any[];
  setState: (state: any[]) => void;
  unAvailabeKeys?: string[];
  isColor?: boolean;
  isFromFilters?: boolean;
  outOfStockKeys?: string[];
  disabledKeys?: string[];
  allow_user_request_stock_availability_reminder?: boolean;
}

const TagsFilter: React.FC<Props> = ({
  filter,
  state,
  setState,
  unAvailabeKeys = [],
  isColor = false,
  isFromFilters,
  outOfStockKeys,
  disabledKeys,
  allow_user_request_stock_availability_reminder,
}) => {
  const options = filter.data;
  const t = useTranslation();
  const [showMore, setShowMore] = useState(!isFromFilters);
  const initialMaxItems = 8;

  const multiSelect = filter.configurations.is_multi_select;

  const handleOption = (key: string) => {
    const currentSelected = toggleOption(state, key, multiSelect);
    setState(currentSelected);
  };
  if (options?.length === 0) return null;
  return (
    <>
      <Row
        as="ul"
        style={{
          columnGap: 16,
          rowGap: 8,
          padding: 0,
          margin: 0,
          listStyleType: "none",
        }}
        className="tags-options"
      >
        {options
          ?.filter(
            (op, idx) =>
              !isSelected(unAvailabeKeys, op.key) &&
              (showMore || idx < initialMaxItems),
          )
          ?.map((option, key) => {
            const { disabled, outOfStock, allowSelectOutOfStock } =
              getOptionAvailability({
                optionKey: option.key,
                unAvailabeKeys,
                outOfStockKeys,
                disabledKeys,
                allowRequestStockReminder:
                  allow_user_request_stock_availability_reminder,
              });
            return (
              <Col as="li" className="p-0 col-auto" key={option.key}>
                {isColor ? (
                  <SvgColorOption
                    key={option.key}
                    disabled={disabled}
                    selected={isSelected(state, option.key)}
                    toggleOption={() => handleOption(option.key)}
                    color={option.value}
                    outOfStock={outOfStock}
                  />
                ) : (
                  <ButtonOption
                    key={key}
                    text={option.value}
                    disabled={disabled}
                    selected={isSelected(state, option.key)}
                    toggleOption={() => handleOption(option.key)}
                    outOfStock={outOfStock}
                    allowSelectOutOfStock={allowSelectOutOfStock}
                  />
                )}
              </Col>
            );
          })}
      </Row>
      {options?.length! > initialMaxItems && !showMore && (
        <Row>
          <span className="filter-show-more" onClick={() => setShowMore(true)}>
            {t.show_more}
          </span>
        </Row>
      )}
    </>
  );
};
export default TagsFilter;
